<script>
import { onMount } from 'svelte'

let isModelLoaded = false
let isLoaderHidden = false
let isSpSize = 768 > window.innerWidth

onMount(() => {
  const modelViewerElm = document.getElementsByTagName('model-viewer')[0]

  modelViewerElm.addEventListener('load', () => {
    isModelLoaded = true
    setTimeout(() => {
      isLoaderHidden = true
    }, 1000)
  })
})
</script>

<div id="model-viewer" class={
    'model-viewer' +
    (isModelLoaded ? ' is-model-loaded' : '') +
    (isLoaderHidden ? ' is-loader-hidden' : '')
  }>
  {#if !isLoaderHidden}
    <div class="loader">
      <p class="loader-text">
        {#each '3Dモデルの読み込み中' as chara, i}
          <span class="chara" style={`animation-delay: ${0.05*i}s;`}>{chara}</span>
        {/each}
      </p>
    </div>
  {/if}
  <model-viewer
    src="/assets/model.glb"
    ios-src="/assets/model.usdz"
    alt="KAKUSIN - HAPPY NEW YEAR 2020"
    background-color="#18bdff"
    style="width: 100%; height: 100%; --progress-bar-color: #fff;"
    ar
    ar-scale="auto"
    auto-rotate
    camera-controls
    camera-orbit={`5deg 90deg ${isSpSize ? 0.5 : 0.6}m`}
    camera-target="0m -0.13m 0m"
    magic-leap
    interaction-prompt-style
    unstable-webxr />
  <div class="info">
    <div class="info-pc">
      <p class="info-text">
        {#each 'スマートフォンでアクセスして' as chara, i}
          <span class="chara" style={`animation-delay: ${4+0.05*i}s;`}>{chara}</span>
        {/each}
        <br>
        {#each 'ARを表示してください' as chara, i}
          <span class="chara" style={`animation-delay: ${4+0.05*(i+11)}s;`}>{chara}</span>
        {/each}
      </p>
      <img class="info-qr" src="/assets/qr.png" alt="このページのQRコード">
    </div>
    <div class="info-sp">
      <p class="info-text">
        {#each 'こちらのボタンをクリックして' as chara, i}
          <span class="chara" style={`animation-delay: ${4+0.05*i}s;`}>{chara}</span>
        {/each}
        <br>
        {#each 'ARを表示してください' as chara, i}
          <span class="chara" style={`animation-delay: ${4+0.05*(i+14)}s;`}>{chara}</span>
        {/each}
      </p>
    </div>
  </div>
  <script type="module" src="https://unpkg.com/@google/model-viewer/dist/model-viewer.js"></script>
  <script nomodule src="https://unpkg.com/@google/model-viewer/dist/model-viewer-legacy.js"></script>
</div>

<style>
.loader {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  color: #fff;
  font-size: 24px;
  letter-spacing: .1em;
  transition: opacity 1s;
}
.is-model-loaded .loader {
  opacity: 0;
}
.loader .chara {
  display: inline-block;
  animation: loader-chara-jump 2s infinite;
}
@keyframes loader-chara-jump {
  0% {
    transform: translate3d(0, 0, 0);
  }
  10% {
    transform: translate3d(0, -20%, 0);
  }
  20% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
.model-viewer {
  height: 100%;
}
.info {
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  text-align: right;
  color: #fff;
  pointer-events: none;
}
.is-loader-hidden .info-text {
  margin: 0;
}
.is-loader-hidden .info-text .chara {
  display: inline-block;
  animation: info-chara-jump 6s infinite;
}
@keyframes info-chara-jump {
  0% {
    transform: translate3d(0, 0, 0);
  }
  3% {
    transform: translate3d(0, -15%, 0);
  }
  6% {
    transform: translate3d(0, 0, 0);
  }
  100% {
    transform: translate3d(0, 0, 0);
  }
}
.info-pc {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 60px 60px 0;
}
.info-qr {
  width: 80px;
  margin-left: 15px;
}
.info-sp {
  display: none;
  padding: 0 65px 12px 0;
}
@media screen and (max-width: 768px) {
  .info-pc {
    display: none;
  }
  .info-sp {
    display: block;
  }
}
.info {
  opacity: 0;
  transform: translate3d(-20px, 0, 0);
}
.is-loader-hidden .info {
  opacity: 1;
  transform: translate3d(0, 0, 0);
  transition: opacity .5s 1s, transform .5s 1s;
}
</style>
